module.exports = __webpack_public_path__ + "static/media/DSC_6694.2287ee59.jpg";